export default {
  questions: {
    openConversational: {
      openEndPlaceholder: "Lütfen metninizi buraya girin",
      conversationalPlaceholder: "Lütfen cevabınızı buraya girin",
      conversationClosed: "Konuşma kapatıldı.",
      conversationalDisclaimer: "Takip soruları, yanıtlarınıza göre AI tarafından oluşturulacaktır."
    },
    openText: {
      openEndPlaceholder: "Lütfen metninizi buraya girin"
    },
    multiText: {
      fieldPlaceholder: 'Yanıt {number}',
      instruction: 'Aşağıya en az {count} yanıt yazın, her metin kutusuna bir tane',
      instructionWithoutMinimum: 'Yanıtlarınızı aşağıya yazın, her metin kutusuna bir tane',
      minimumEntries: 'Devam etmek için lütfen en az {count} yanıt girin.',
      unaidedBrandAwareness: {
        fieldPlaceholder: 'Marka {number}',
        minimumEntries: 'Devam etmek için lütfen en az {count} marka girin.'
      }
    },
    multiselect: {
      caption: "Uygun olanların tümünü seçin"
    },
    rankOrder: {
      enterRankOrder: "Sıralamayı girin",
      placeholder: "Tercihlerinizi sıralamak için buraya sürükleyin"
    },
    openNumeric: {
      label: "Açık Sayısal"
    },
    complete: {
      message: "Bu anketi doldurduğunuz için teşekkür ederiz."
    },
    openVideo: {
      warning: "Lütfen devam etmeden önce bir video kaydedin.",
      uploadStatusUploading: "Devam etmek için videonuzu işlememizi lütfen bekleyin...",
      uploadStatusSuccess: "Yükleme başarılı, devam edebilirsiniz.",
      uploadStatusError: "Yükleme tamamlanmadı, lütfen tekrar deneyin."
    }
  },
  errors: {
    node: {
      text_invalid_email: 'Lütfen geçerli bir e-posta girin',
      text_invalid_phone: 'Lütfen geçerli bir telefon numarası girin',
      text_invalid_us_zip: 'Lütfen geçerli bir ABD posta kodu (ZIP) girin',
      text_invalid_ca_postal: 'Lütfen geçerli bir Kanada posta kodu girin',
      text_invalid_uk_postal: 'Lütfen geçerli bir Birleşik Krallık posta kodu girin',
      text_invalid_custom: 'Lütfen geçerli bir {fieldName} girin',
      text_min_chars: 'Lütfen en az {min} karakter girin',
      text_max_chars: 'Lütfen en fazla {max} karakter girin',
      text_alpha_not_allowed: 'Yalnızca rakamlara izin verilir',
      text_numeric_not_allowed: 'Yalnızca harflere izin verilir'
    },
    external: {
      invalid: 'Bu soruya verilen yanıt geçerli değil.',
      required: 'Bu sorunun yanıtlanması gereklidir.',
      singlechoice_required: 'Devam etmeden önce lütfen bir seçenek seçin.',
      numeric_required: 'Devam etmeden önce lütfen bir puan seçin.',
      text_required: 'Devam etmeden önce lütfen bir yanıt girin.',
      bigtext_required: 'Devam etmeden önce lütfen bir yanıt girin.',
      singlechoiceother_incomplete: 'Devam etmeden önce lütfen bir yanıt girin.',
      multiselectother_incomplete: 'Devam etmeden önce lütfen bir yanıt girin.',
      numeric_invalid: 'Devam etmeden önce lütfen geçerli bir sayı girin.',
      radiogrid_required: 'Devam etmeden önce lütfen her satır için bir seçenek seçin.',
      incomplete: 'Devam etmeden önce lütfen bu soruyu eksiksiz tamamlayın.',
      multiselect_min: 'Devam etmeden önce lütfen en az {value} seçenek seçin.',
      multiselect_max: 'Devam etmeden önce lütfen en fazla {value} seçenek seçin.',
      multiselectother_min: 'Devam etmeden önce lütfen en az {value} seçenek seçin.',
      multiselectother_max: 'Devam etmeden önce lütfen en fazla {value} seçenek seçin.',
      multiselectgrid_min: 'Devam etmeden önce lütfen her satır için en az {value} seçenek seçin.',
      multiselectgrid_max: 'Devam etmeden önce lütfen her satır için en fazla {value} seçenek seçin.',
      rankorder_min: 'Devam etmeden önce lütfen en az {value} öğeyi sıralayın.',
      rankorder_max: 'Devam etmeden önce lütfen en fazla {value} öğeyi sıralayın.'
    }
  }
}
